import React from "react";

import "./App.css";

import Counter from "./components/Counter";

import Footer from "./components/Footer";

const App = () => {
    return (
        <main className="min-h-screen  boxShadowSmall  sm:boxShadow">
            <Counter />
            <Footer />
        </main>
    );
};

export default App;
